import {
  AddressRowValues,
  DietaryRequirementsRowValues,
  TravelerPolicyAllowanceRow,
  TravelerValues,
} from './interfaces';

export const ADDRESS_INITIAL_VALUES: AddressRowValues = {
  id: null,
  _rowTimestamp: null,
  addressLine1: null,
  addressLine2: null,
  cityName: null,
  countryId: null,
  stateRegionId: null,
  postalCode: null,
  telephoneNumber: null,
  emailAddress: null,
  isGroundTransferAddress: null,
  isDeliveryAddress: null,
  isPrimary: null,
};

export const TRAVEL_POLICY_ALLOWANCE_VALUES: TravelerPolicyAllowanceRow = {
  id: null, //id of the checkbox
  expenditureType: null,
  allowanceOverrideAmount: null,
  _allowanceDescription: null,
  isAllowanceCustomizable: null,
  _travelerPolicyAllowanceRowTimestamp: null,
  _travelerPolicyAllowanceId: null, // id of the allowance created
  isChecked: null,
};

export const DIETARY_REQUIREMENTS_INITIAL_VALUES: DietaryRequirementsRowValues =
  {
    id: null,
    _rowTimestamp: null,
    _isDeletable: true,
    description: null,
    dietaryRequirementId: null,
    isDescriptionRequired: null,
  };

export const TRAVELER_INITIAL_VALUES: TravelerValues = {
  firstName: null,
  companyOrLastName: null,
  travelerDepartmentId: null,
  userOccupationTitleId: null,
  travelerCompanionTickets: null,
  travelerCompanionAmount: null,
  travelerCompanionMasterId: null,
  // fareClass: null,
  seatPreference: null,
  travelPolicyId: null,
  frequentFlyerNumber: null,
  isEconomyClassPreferred: false,
  isFirstClassPreferred: false,
  isBusinessClassPreferred: false,
  isCharterClassPreferred: false,
  isPremiumClassPreferred: false,
  travelerAddressesByTravelerId: [
    { ...ADDRESS_INITIAL_VALUES, isPrimary: true },
  ],
  travelerPolicyAllowancesByTravelerId: [{ ...TRAVEL_POLICY_ALLOWANCE_VALUES }],
  travelerDietaryRequirementsByTravelerId: [
    { ...DIETARY_REQUIREMENTS_INITIAL_VALUES },
  ],
};
